import React from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";

type Props = {
    searchTerm?: string;
    onClearFilters: () => void;
    onBrowseAll: () => void;
};

export const EcommerceNoResults: React.FC<Props> = ({ searchTerm, onClearFilters, onBrowseAll }) => {
    return (
        <Container className="d-flex flex-column align-items-center text-center w-100 py-5">
            <IconContainer>
                <i className="fas fa-magnifying-glass" />
                <XBadge>
                    <i className="fas fa-xmark" />
                </XBadge>
            </IconContainer>

            <h3 className="mt-4 mb-3">
                <FormattedMessage id="no_results_found_title" />
            </h3>

            {searchTerm && (
                <p className="text-muted mb-4">
                    <FormattedMessage id="no_results_search_message" /> <SearchTerm>&quot;{searchTerm}&quot;</SearchTerm>
                </p>
            )}

            <SuggestionBox className="p-4 mb-4">
                <p className="fw-semibold mb-3">
                    <FormattedMessage id="no_results_try_following" />
                </p>
                <ul className="text-start text-muted mb-0">
                    <li>
                        <FormattedMessage id="no_results_tip_spelling" />
                    </li>
                    <li>
                        <FormattedMessage id="no_results_tip_general" />
                    </li>
                    <li>
                        <FormattedMessage id="no_results_tip_filters" />
                    </li>
                </ul>
            </SuggestionBox>

            <div className="d-flex gap-3 flex-wrap justify-content-center">
                <button className="btn btn-primary" onClick={onClearFilters}>
                    <i className="fas fa-rotate me-2" />
                    <FormattedMessage id="clear_filters" />
                </button>
                <button className="btn btn-secondary" onClick={onBrowseAll}>
                    <i className="fas fa-filter me-2" />
                    <FormattedMessage id="browse_all_products" />
                </button>
            </div>
        </Container>
    );
};

const Container = styled.div`
    color: var(--main-text-color);
    // Span the full row when rendered inside the ecomm-grid so the content centers
    grid-column: 1 / -1;
`;

const IconContainer = styled.div`
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: rgba(0, 123, 255, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;

    .fa-magnifying-glass {
        font-size: 2.5rem;
        color: var(--primary);
    }
`;

const XBadge = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: var(--secondary-bg-color);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid var(--main-bg-color);

    .fa-xmark {
        font-size: 1rem;
        color: var(--main-text-color);
    }
`;

const SearchTerm = styled.span`
    color: var(--primary);
    font-weight: 600;
`;

const SuggestionBox = styled.div`
    background: var(--secondary-bg-color);
    border: 1px solid var(--minor-bg-color);
    border-radius: 0.5rem;
    max-width: 500px;

    ul {
        list-style-type: disc;
        padding-left: 1.5rem;
    }

    li {
        margin-bottom: 0.5rem;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;
